module.exports = __webpack_public_path__ + "img/menu-image.27ddee1f.png";